export class StringParser {
    /** @inheritdoc */
    parseValue(rawValue) {
        return String(rawValue);
    }
}
// use a shared static instance for performance instead of
// instantiating a new instance for every use
StringParser.shared = new StringParser();
//# sourceMappingURL=string.js.map